import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

import { DayjsFormat } from "@/common/useQueryDateSelect"

dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

export default dayjs

// 不传 tz 时沿用 dayjs.tz.setDefault()（已由 UserInfoStore 注入店铺时区）
// 显式传 tz 时按传入的 IANA 时区计算，避免对 setDefault 时机的隐式依赖
export const today = (tz?: string) => {
  const d = tz ? dayjs().tz(tz) : dayjs().tz()
  return d.format(DayjsFormat.YMD)
}

export const subtractDay = (val: number, tz?: string) => {
  const d = tz
    ? dayjs().tz(tz).subtract(val, "day")
    : dayjs().tz().subtract(val, "day")
  return d.format(DayjsFormat.YMD)
}

export const disabledRange = (day = 365, tz?: string) => [
  dayjs(subtractDay(day - 1, tz)).toDate(),
  dayjs(today(tz)).toDate(),
]
export const toLocalDateByDateParts = (date: dayjs.Dayjs) =>
  new Date(date.year(), date.month(), date.date())
